export async function maintainAccounts(payload) {
  const user = window.firebaseAuth?.currentUser;
  if (!user || user.isAnonymous) throw new Error('Verified sign-in required.');
  const token = await user.getIdToken();
  if (window.firebaseAuth.currentUser !== user) throw new Error('Your sign-in changed.');
  const response = await fetch('https://us-central1-argumentor-ff17a.cloudfunctions.net/maintainAccounts', {
    method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify(payload), cache: 'no-store',
  });
  const result = await response.json();
  if (window.firebaseAuth.currentUser !== user) throw new Error('Your sign-in changed.');
  if (!response.ok) throw new Error(result.error || 'Account maintenance failed.');
  return result;
}
